'use client';
import { Box, Typography } from '@mui/material';

import { useT } from '@/hooks';

interface MobileTradeSummaryProps {
  activeTab: 'buy' | 'sell';
  totalCost: number;
  potReturn: number;
  potProfit: number;
  avgPrice?: number;
}

export function MobileTradeSummary({
  activeTab,
  totalCost,
  potReturn,
  potProfit,
  avgPrice,
}: MobileTradeSummaryProps) {
  const { t } = useT();
  return (
    <Box sx={{ mb: 2.5, p: 2, borderRadius: '8px', bgcolor: 'action.hover' }}>
      {activeTab === 'buy' ? (
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mb: 1.5,
            }}
          >
            <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary', fontWeight: 500 }}>
              {t('trade.totalCost')}
            </Typography>
            <Typography sx={{ fontSize: '0.875rem', color: 'text.primary', fontWeight: 700 }}>
              ${totalCost.toFixed(2)}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mb: 1.5,
            }}
          >
            <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary', fontWeight: 500 }}>
              {t('trade.youllReceive')}
            </Typography>
            <Typography sx={{ fontSize: '0.875rem', color: 'primary.main', fontWeight: 700 }}>
              ${potReturn.toFixed(2)}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary', fontWeight: 500 }}>
              {t('trade.estimatedProfit')}
            </Typography>
            <Typography sx={{ fontSize: '0.875rem', color: '#22c55e', fontWeight: 700 }}>
              ${potProfit.toFixed(2)}
            </Typography>
          </Box>
        </>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary', fontWeight: 500 }}>
            {t('trade.youllReceive')}
          </Typography>
          <Typography sx={{ fontSize: '0.875rem', color: '#22c55e', fontWeight: 700 }}>
            ${potReturn.toFixed(2)}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
